import { useAuth } from '../hooks/useAuth';

export const AdminAccess = ({ children, requireMainAdmin = false }) => {
    const { user } = useAuth();

    if (!user) return null;

    // Если требуется главный админ и пользователь не главный админ
    if (requireMainAdmin && user.role !== 'main_admin') {
        return null;
    }

    // Если пользователь не админ вообще
    if (!['main_admin', 'store_admin'].includes(user.role)) {
        return null;
    }

    return children;
};

export const StoreAdminAccess = ({ children }) => {
    const { user } = useAuth();

    if (!user || user.role !== 'store_admin') {
        return null;
    }

    return children;
};

export const MainAdminAccess = ({ children }) => {
    const { user } = useAuth();

    if (!user || user.role !== 'main_admin') {
        return null;
    }

    return children;
}; 